import { forwardRef } from 'react';
import EmailRecipientSearchInput from './EmailRecipientSearchInput';
import { reportError } from 'conversations-error-reporting/error-reporting/reportError';
import { jsx as _jsx } from "react/jsx-runtime";
function DeliveryIdentifierSearchInput({
  deliveryIdentifier,
  autoFocus,
  clearableValues,
  value,
  onChange,
  onFocus,
  defaultRecipient,
  index,
  relatedRecipients,
  emailBlocklistStatus
}, ref) {
  if (deliveryIdentifier === 'email') {
    return /*#__PURE__*/_jsx(EmailRecipientSearchInput, {
      autoFocus: autoFocus,
      clearableValues: clearableValues,
      value: value,
      onChange: onChange,
      onFocus: onFocus,
      defaultRecipient: defaultRecipient,
      index: index,
      relatedRecipients: relatedRecipients,
      ref: ref,
      emailBlocklistStatus: emailBlocklistStatus
    });
  }
  reportError({
    error: new Error(`Unexpected deliveryIdentifier provided to DeliveryIdentifierSearchInput: ${deliveryIdentifier}`),
    extra: {
      defaultRecipient,
      value: value && value.toJS()
    }
  });
  return /*#__PURE__*/_jsx(EmailRecipientSearchInput, {
    autoFocus: autoFocus,
    clearableValues: clearableValues,
    value: value,
    onChange: onChange,
    onFocus: onFocus,
    defaultRecipient: defaultRecipient,
    index: index,
    relatedRecipients: relatedRecipients,
    ref: ref,
    emailBlocklistStatus: emailBlocklistStatus
  });
}
DeliveryIdentifierSearchInput.displayName = 'DeliveryIdentifierSearchInput';
export default /*#__PURE__*/forwardRef(DeliveryIdentifierSearchInput);